<template>
  <div class="animated fadeIn">
    <div class="card">
      <!-- <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} phản hồi</span>
        <span v-if="mData.viewMode == 'updateTcqltt'">{{aLang.c_changeStatus}} xử lý phản hồi</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} phản hồi</span>
        <div class="card-header-actions"></div>
      </div>-->
      <div class="card-body">
        <el-form
          :model="mData.dataFormOther"
          :rules="mData.validFormOther"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item label="Người xử lý hiện tại" prop="tcqltt.nguoi_xu_ly_id">
                <el-select
                  v-model="mData.dataFormOther.tcqltt.nguoi_xu_ly_id"
                  :placeholder="aLang.c_select"
                  disabled
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.currentUser"
                    :key="item.id"
                    :label="item.account"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Trạng thái xử lý của TCQLTT" prop="tcqltt.trang_thai">
                <el-select
                  v-model="mData.dataFormOther.tcqltt.trang_thai"
                  @change="fn_changeStatusComplete(mData.dataFormOther.tcqltt.trang_thai)"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'|| mData.dataFormOther.tcqltt.nguoi_xu_ly_id!=mData.dataDefault.nguoiXuLyTCQLTT"
                  :clearable="false"
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThaiTcqltt"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="(mData.dataFormOther.tcqltt.nguoi_xu_ly_id && mData.dataFormOther.tcqltt.nguoi_xu_ly_id != mData.dataDefault.nguoiXuLyTCQLTT) || (mData.dataFormOther.tcqltt.trang_thai && mData.dataFormOther.tcqltt.trang_thai == 'processing')">
              <el-form-item label="Chuyển người xử lý" prop="lich_su.den">
                <el-select
                  v-model="mData.dataFormOther.lich_su.den"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNguoiDung"
                    :key="item.id"
                    :label="item.account"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Lý do chuyển trạng thái" prop="lich_su.ly_do">
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="mData.dataFormOther.lich_su.ly_do"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <el-form-item class="mb-0" label="File đính kèm">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.FileDinhKemTCQLTT.limit"
                  :accept="mData.fileUploadOption.FileDinhKemTCQLTT.accept"
                  :on-change="fn_uploadChangeFileDinhKemTCQLTT"
                  :on-preview="fn_uploadPreviewFileDinhKemTCQLTT"
                  :on-remove="fn_uploadRemoveFileDinhKemTCQLTT"
                  :on-exceed="fn_uploadExceedFileDinhKemTCQLTT"
                  multiple
                  :file-list="mData.fileUploadOption.FileDinhKemTCQLTT.fileList"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.FileDinhKemTCQLTT.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.fileUploadOption.FileDinhKemTCQLTT.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>-->
          <b-row>
            <b-col md="6">
              <el-form-item class="mb-0" label="File đính kèm">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture"
                  :limit="mData.fileUploadOption.FileDinhKemTCQLTT.limit"
                  :accept="mData.fileUploadOption.FileDinhKemTCQLTT.accept"
                  :on-change="fn_uploadChangeFileDinhKemTCQLTT"
                  :on-preview="fn_uploadPreviewFileDinhKemTCQLTT"
                  :on-remove="fn_uploadRemoveFileDinhKemTCQLTT"
                  :on-exceed="fn_uploadExceedFileDinhKemTCQLTT"
                  multiple
                  :file-list="mData.fileUploadOption.FileDinhKemTCQLTT.fileList"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-button
                    size="small"
                    type="primary"
                    :disabled="mData.viewMode == 'detail'"
                  >Chọn tệp</el-button>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.FileDinhKemTCQLTT.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.fileUploadOption.FileDinhKemTCQLTT.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="noi_dung">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="mData.dataForm.noi_dung"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>-->

          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>-->

            <el-button
              type="info"
              plain
              @click="fn_submitForm('updateTcqltt')"
              v-ladda
              v-if="mData.viewMode == 'updateTcqltt'"
            >{{aLang.c_update}}</el-button>

            <!-- <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../service/LanguageService";
import DataService from "../service/DataService";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";
import PhanHoiModel from "../views/admin/PhanHoi/PhanHoiModel";
import PhanHoiApi from "../moduleApi/PhanHoiApi";
import NhomPhanHoiApi from "../moduleApi/NhomPhanHoiApi";
// import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
// import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import NguoiDungTcqlttApi from "../moduleApi/NguoiDungTcqlttApi";
import NguoiDungTcqlttModel from "../views/admin/NguoiDungTcqltt/NguoiDungTcqlttModel";
import AccountApi from "../moduleApi/AccountApi";
// import TourApi from "../../../moduleApi/TourApi";
// import FileApi from "../../../moduleApi/FileApi";
import CauHinhApi from "../moduleApi/CauHinhApi";
// import MailingService from "../service/MailingService";
import ValidService from '../service/ValidService';

export default {
  props: {
    componentProps: {
      id: String,
      mode: String
    }
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "PhanHoi",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          // listCongTyLuHanh: [],
          listNguoiGuiPhanHoi: [],
          // listTour: [],
          listNhomPhanHoi: [],
          listLichSu: [],
          listDoiTuongPhanHoi: MethodService.copyObject(
            PhanHoiModel.doiTuongPhanHoi
          ),
          trangThai: PhanHoiModel.trangThai,
          trangThaiTcqltt: PhanHoiModel.trangThaiTcqltt,
          // tcqlttItem: MethodService.copyObject(PhanHoiModel.dataFormOther.tcqltt),
          // lichSuItem:MethodService.copyObject(PhanHoiModel.dataFormOther.lich_su),
          listNguoiDung: [],
          currentUser: null,
          nguoiXuLyTCQLTT: ""
        },
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        dataFormOther: MethodService.copyObject(PhanHoiModel.dataFormOther),
        validForm: PhanHoiModel.validForm,
        validFormOther: PhanHoiModel.validFormOther,
        fileUploadOption: MethodService.copyObject(
          PhanHoiModel.dataFormOther.fileUploadOption
        ),
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        try {

          if (!valid){
            MethodService.stopLadda();
            return;
          } 

          if (type !== "updateTcqltt") {
            MethodService.stopLadda();
            return;
          } 

          if (this.mData.dataFormOther.tcqltt.trang_thai != "processing" && this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id == this.mData.dataDefault.nguoiXuLyTCQLTT) {
            this.mData.dataFormOther.lich_su.den = this.mData.dataDefault.nguoiXuLyTCQLTT;
          }

          if (!this.mData.dataFormOther.lich_su.den) {
            window.toastr.error("Thiếu dữ liệu", "Bạn hãy chọn người xử lý");
            return;
          }

          let lichSuItem = MethodService.copyObject(
            PhanHoiModel.dataFormOther.lich_su
          );
          
          let tcqlttItem = MethodService.copyObject(
            PhanHoiModel.dataFormOther.tcqltt
          );

          let currentUser = MethodService.getCurrentUser();

          if (
            this.mData.dataFormOther.tcqltt &&
            this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id
          ) {
            lichSuItem.tu = this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id;
          }
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.den
          ) {
            lichSuItem.den = this.mData.dataFormOther.lich_su.den;
          }
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.ly_do 
          ) {
            lichSuItem.ly_do = this.mData.dataFormOther.lich_su.ly_do.trim();
          }
          lichSuItem.thoi_diem = new Date();
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.file_dinh_kem &&
            this.mData.dataFormOther.lich_su.file_dinh_kem.length > 0
          ) {
            lichSuItem.file_dinh_kem = this.mData.dataFormOther.lich_su.file_dinh_kem;
          }

          if (
            currentUser.account == "tcqltt" &&
            this.mData.dataForm.tcqltt.lich_su &&
            this.mData.dataForm.tcqltt.lich_su.length > 0 &&
            this.mData.dataFormOther.lich_su.den ==
              this.mData.dataForm.tcqltt.lich_su[0].tu
          ) {
            tcqlttItem.trang_thai = this.mData.dataFormOther.tcqltt.trang_thai;
            lichSuItem.trang_thai = this.mData.dataFormOther.tcqltt.trang_thai;
          } else {
            let resFindNguoi = await NguoiDungTcqlttApi.list({
              filters:
                "id:in:" +
                this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id +
                "&parent_id:in:" +
                this.mData.dataFormOther.lich_su.den
            });
            if (resFindNguoi.result && resFindNguoi.result.length > 0) {
              tcqlttItem.trang_thai = "waiting";
              lichSuItem.trang_thai = "waiting";
            } else {
              tcqlttItem.trang_thai = this.mData.dataFormOther.tcqltt.trang_thai;
              lichSuItem.trang_thai = this.mData.dataFormOther.tcqltt.trang_thai;
            }
            tcqlttItem.nguoi_xu_ly_id = this.mData.dataFormOther.lich_su.den;
          }

          tcqlttItem.lich_su = this.mData.dataForm.tcqltt.lich_su;
          tcqlttItem.lich_su.push(lichSuItem);
          this.mData.dataForm.tcqltt = tcqlttItem;

          if (
            !this.mData.dataForm ||
            !this.mData.dataForm.loc ||
            !this.mData.dataForm.loc.type
          ) {
            this.mData.dataForm.loc.type = "Point";
          }
          if (
            !this.mData.dataForm ||
            !this.mData.dataForm.loc ||
            !this.mData.dataForm.loc.coordinates ||
            this.mData.dataForm.loc.coordinates.length < 2
          ) {
            this.mData.dataForm.loc.coordinates = [null, null];
          }

          this.mData.dataForm.id = this.componentProps.id;
          await PhanHoiApi.updateSend(this.mData.dataForm);
          // chuyển xử lý gửi mail từ BE (task 60473)
          // if(this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id != this.mData.dataFormOther.lich_su.den){
          //   await MailingService.sendEmailTcqltt(
          //     this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id,
          //     this.mData.dataFormOther.lich_su.den
          //   );
          // }
          
          window.location.reload();
        }
        finally {
          MethodService.stopLadda();
        }
      });
    },
    fn_resetForm() {
      this.mData.fileUploadOption = MethodService.copyObject(
        PhanHoiModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      this.mData.dataFormOther = MethodService.copyObject(PhanHoiModel.dataFormOther);
      let res = await PhanHoiApi.findById(id);
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(PhanHoiModel.dataForm),
        res.result
      );

      let resNguoiDung = await NguoiDungTcqlttApi.findById(
        resData.tcqltt.nguoi_xu_ly_id
      );
      if (resNguoiDung.result) {
        let resNguoiDungData = MethodService.checkDifferentObject(
          MethodService.copyObject(NguoiDungTcqlttModel.dataForm),
          resNguoiDung.result
        );
        let NguoiDunglist = resNguoiDungData.children;
        if (resNguoiDung.result.parent_id) {
          NguoiDunglist.push(resNguoiDung.result.parent_id);
        }

        let currentUser = MethodService.getCurrentUser();
        if (currentUser.account == "tcqltt") {
          if (resData.tcqltt.lich_su && resData.tcqltt.lich_su.length > 0) {
            NguoiDunglist.push(resData.tcqltt.lich_su[0].tu);
          }
        }

        let resNguoiDungList = await AccountApi.list({
          filters: "id:in:" + NguoiDunglist.join(",")
        });
        this.mData.dataDefault.listNguoiDung = resNguoiDungList.result;
      }

      let resCurrentList = await AccountApi.list({
        filters: "id:in:" + resData.tcqltt.nguoi_xu_ly_id
      });
      this.mData.dataDefault.currentUser = resCurrentList.result;

      this.mData.dataDefault.tcqlttItem = resData.tcqltt;
      this.mData.dataDefault.lichSuItem = resData.tcqltt.lich_su;
      this.mData.dataFormOther.tcqltt = resData.tcqltt;
      // this.mData.dataFormOther.lich_su=resData.tcqltt.lich_su;

      this.mData.dataForm = resData;
      this.fn_changeStatusComplete(this.mData.dataForm.tcqltt.trang_thai);
      console.log("this.mData.dataForm",this.mData.dataForm);
      // console.log(this.mData.dataFormOther.tcqltt.nguoi_xu_ly_id==this.mData.dataDefault.nguoiXuLyTCQLTT);
    },
    async fn_initDataDefault() {
      let reqNhomPhanHoiApi = NhomPhanHoiApi.list({ limit: 1000 });
      let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
      this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;

      let resNguoiXuLyTCQLTT = await CauHinhApi.list({
        filters: "code:in:default_user_tcqltt_id"
      });
      if (resNguoiXuLyTCQLTT) {
        this.mData.dataDefault.nguoiXuLyTCQLTT =
          resNguoiXuLyTCQLTT.result[0].value;
      }
    },

    fn_uploadRemoveFileDinhKemTCQLTT(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataFormOther.lich_su.file_dinh_kem = data;
    },
    fn_uploadChangeFileDinhKemTCQLTT(file, fileList) {
      // debugger
      ExtensionService.upload(file, "phanHoiTcqltt")
        .then(res => {
          // debugger
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.file_dinh_kem
          ) {
            this.mData.dataFormOther.lich_su.file_dinh_kem.push(res.result);
          } else {
            this.mData.dataFormOther.lich_su.file_dinh_kem = [];
            this.mData.dataFormOther.lich_su.file_dinh_kem.push(res.result);
          }
          // this.mData.dataFormOther.lich_su.file_dinh_kem.push(res.result);

          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          // debugger
          this.mData.fileUploadOption.FileDinhKemTCQLTT.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedFileDinhKemTCQLTT(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKemTCQLTT.limit} file`
      );
    },
    fn_uploadPreviewFileDinhKemTCQLTT(file) {
      this.mData.fileUploadOption.FileDinhKemTCQLTT.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKemTCQLTT.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_changeStatusComplete(status){
      if(status == "processed"){
        this.mData.validFormOther.lich_su.ly_do = [ValidService.required,ValidService.checkSpaceString];
      }else{
        this.mData.validFormOther.lich_su.ly_do = [];
      }
    },
    fn_init() {
      this.fn_initDataDefault();
      if (this.componentProps.mode == "update") {
        this.mData.viewMode = "update";
      }
      if (this.componentProps.mode == "updateTcqltt") {
        this.mData.viewMode = "updateTcqltt";
      }
      if (this.componentProps.mode == "detail") {
        this.mData.viewMode = "detail";
      }
      if (this.componentProps.id) {
        this.fn_getDataById(this.componentProps.id);
      }
    }
  },
  created: function() {
    this.fn_init();
  },
  mounted: function() {
  },
  watch: {
    componentProps: function() {
      this.fn_init();
    }
  }
};
</script>
